import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function linkButton(theme: Theme): ComponentStyle {
  return {
    componentName: 'linkButton',
    baseStyle: {
      display: 'flex',
      alignItems: 'center',
      fontSize: theme.sizes['-1'],
      fontWeight: 600,
      color: theme.colors.spark.gray40,
      backgroundColor: theme.colors.foreground,
      borderRadius: theme.sizes['-4'],

      ['&:hover']: {
        backgroundColor: theme.colors.spark.gray90
      }
    },
    variants: {
      sparkApp: {
        textWrap: 'nowrap',
        fontSize: theme.sizes['0']
      }
    }
  };
}
